/*
 *   File : thematic.js
 *   Author : https://evoqins.com
 *   Description : Thematic tab data component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';
import { useNavigate } from 'react-router-dom';

//Custom components
import { BasketCard } from '../../../Components/Card';
import { PrimaryButton } from '../../../Components/Buttons';

const Thematic = (props) => {

    const navigate = useNavigate();

    // // handle navigate create  basket
    // const _handleCreateBasket = () => {
    //     navigate("manage-basket", {
    //         state: {
    //             selected_tab: 2,
    //             edit: false
    //         }
    //     });
    // };

    return (
        <div className='text-end '>
            {/* <PrimaryButton name="Create New Basket"
                paddingBlock="padding-12px-tb"
                className="px-4"
                onClick={_handleCreateBasket} /> */}

            {/* Basket card */}
            <div className='row row-gap-3 pt-4'>
                {props.basketData.map((data, key) => (
                    <div key={key} className='col-6'>
                        <BasketCard basketData={data}
                            selectedTab={props.selectedTab}
                            type={2}
                            handleRebalance={() => props.handleRebalance(data)} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Thematic;
